import { Cell, FormControl, Grid, Paper, Text, Theme, useStyles, VFlow } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { RadioFieldContainer } from 'components/form/field/RadioFieldContainer'
import { resolveValue } from 'components/form/final-form/useField'
import React from 'react'
import { useFormState } from 'react-final-form'
import Permissions from 'types/Permissions'
import { MetaPath } from 'util/metaPath'
import { NovoAtendimentoForm } from 'view/atendimentos/detail/soap/desfecho/components/NovoAtendimentoForm'
import { NovoAtendimentoFormModel } from 'view/atendimentos/model'
import { AgendamentoDia } from 'view/atendimentos/types/AgendamentoDia'

export enum ManterCidadaoLista {
  SIM = 'SIM',
  NAO = 'NAO',
}

export interface DesfechoAtendimentoFormModel {
  manterCidadaoLista: ManterCidadaoLista
  novoAtendimento?: NovoAtendimentoFormModel
  novoAtendimentoAgendado?: any
}

export interface DesfechoAtendimentoPanelProps {
  name: MetaPath<DesfechoAtendimentoFormModel>
  agendamentosDia?: AgendamentoDia[]
}

export function DesfechoAtendimentoPanel(props: DesfechoAtendimentoPanelProps) {
  const { name, agendamentosDia } = props

  const { values: formValues } = useFormState({ subscription: { values: true } })
  const { classes } = useStyles(createStyles)

  const manterCidadaoLista = resolveValue(formValues, name.manterCidadaoLista) === ManterCidadaoLista.SIM

  return (
    <FormControl label='Desfecho do atendimento' required>
      <VFlow vSpacing={0.5}>
        <Grid>
          <Cell size={12}>
            <RadioFieldContainer name={name.manterCidadaoLista} value={ManterCidadaoLista.NAO}>
              <Text> Liberar cidadão </Text>
            </RadioFieldContainer>
          </Cell>
          <CheckPermission permission={Permissions.visualizarListaDeAtendimento.cadastrarEditarEExcluir}>
            <Cell size={12}>
              <VFlow>
                <RadioFieldContainer name={name.manterCidadaoLista} value={ManterCidadaoLista.SIM}>
                  <Text> Manter cidadão na lista de atendimentos </Text>
                </RadioFieldContainer>
                {manterCidadaoLista && (
                  <Paper style={classes.dadosAtendimento}>
                    <NovoAtendimentoForm
                      name={name.novoAtendimento}
                      novoAtendimentoAgendado={name.novoAtendimentoAgendado}
                      agendamentosDia={agendamentosDia}
                    />
                  </Paper>
                )}
              </VFlow>
            </Cell>
          </CheckPermission>
        </Grid>
      </VFlow>
    </FormControl>
  )
}

const createStyles = (theme: Theme) => ({
  dadosAtendimento: {
    padding: '1rem',
    borderColor: theme.pallete.gray.c60,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderTop: 'none',
    marginTop: '-1.1rem',
  },
})
